var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('input',{ref:"image_album",attrs:{"type":"file","accept":"image/*","multiple":_vm.multiple},on:{"change":_vm.onSelectImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }